// extracted by mini-css-extract-plugin
export default {"progressBar":"components-progress-bar_progressBar","fill":"components-progress-bar_fill","description":"components-progress-bar_description"};